// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"d27dd9a3","879":"19a25181"}[chunkId] + ".chunk.js";
};